import { createAsyncThunk } from "@reduxjs/toolkit";
import { cloudChiprApi } from "../../../../services/cloudchipr.api";
import { enqueueSnackbarErrorAlert } from "@/components/pages/common/snackbar-alert/EnqueueSnackbarErrorAlert";
import { DimensionEnhancedSharedCost } from "@/store/dimensions/utils/types/common";
import { generateSharedCostPayload } from "@/store/dimensions/utils/helpers/generateSharedCostPayload";

export const createSharedCostByDimensionIdFixedCacheKey =
  "postUsersMeOrganisationsCurrentDimensionsByDimensionIdDimensionSharedCosts-fixed-cache-key";

export const createSharedCostByDimensionAndCategoryIdsThunk = createAsyncThunk(
  "dimensions/createSharedCostByDimensionAndCategoryIds",
  async (
    {
      dimensionId,
      sharedCosts,
    }: {
      dimensionId: string;
      sharedCosts: DimensionEnhancedSharedCost[];
    },
    { dispatch },
  ) => {
    const {
      postUsersMeOrganisationsCurrentDimensionsByDimensionIdDimensionSharedCosts,
    } = cloudChiprApi.endpoints;

    try {
      const promises = sharedCosts.map((sharedCost) => {
        return dispatch(
          postUsersMeOrganisationsCurrentDimensionsByDimensionIdDimensionSharedCosts.initiate(
            {
              dimensionId: dimensionId,
              body: generateSharedCostPayload(sharedCost),
            },
            { fixedCacheKey: createSharedCostByDimensionIdFixedCacheKey },
          ),
        ).unwrap();
      });

      return await Promise.all(promises);
    } catch (e) {
      // @ts-expect-error todo: fix api spec;
      enqueueSnackbarErrorAlert(e?.data?.message);
    }
  },
);
